"use client";
import { useState, useEffect } from "react";
import Sticky from "react-stickynode";
import request from "@/lib/api";
import Image from "next/image";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
  Avatar,
} from "@nextui-org/react";
import { useRouter } from "next/navigation";
import { GiHamburgerMenu } from "react-icons/gi";
import { CiLogout } from "react-icons/ci";

export default function Menu() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [tokenExpired, setTokenExpired] = useState(true);

  const router = useRouter();

  const isTokenExpired = () => {
    if (typeof window !== "undefined") {
      const cookie = document.cookie
        .split(";")
        .find((cookie) => cookie.includes("accessTokenExpire"));

      if (!cookie) return true;

      const expires = cookie.split("=")[1];
      if (Date.now() > Number(expires)) return true;

      return false;
    } else return true;
  };

  useEffect(() => {
    setTokenExpired(isTokenExpired());
  }, []);

  const logout = async () => {
    if (typeof window !== "undefined") {
      document.cookie = `accessTokenExpire=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      const response: any = await request({ url: "/api/logout" });
      // router.reload();
      router.push("/login");
    }
  };

  const goToSection = (id: any) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  const linksStyle =
    "cursor-pointer select-none hover:text-primaryColor text-secondColor font-bold h-full w-full py-2";
  const links = [
    <div
      key="karabots"
      className={linksStyle}
      onClick={() => {
        goToSection("karabots");
      }}
    >
      کاراباتس
    </div>,
    <div
      key="functionality"
      className={linksStyle}
      onClick={() => {
        goToSection("functionality");
      }}
    >
      عملکرد
    </div>,
    <div
      key="about_us"
      className={linksStyle}
      onClick={() => {
        goToSection("about_us");
      }}
    >
      درباره ما
    </div>,
    <div
      key="signaling"
      className={linksStyle}
      onClick={() => {
        goToSection("signaling");
      }}
    >
      سیگنال‌دهی
    </div>,
    <div
      key="algo_trading"
      className={linksStyle}
      onClick={() => {
        goToSection("algo_trading");
      }}
    >
      معاملات الگوریتمی
    </div>,
    <div
      key="cooperation"
      className={linksStyle}
      onClick={() => {
        goToSection("cooperation");
      }}
    >
      مدل همکاری
    </div>,
    <Button
      as="a"
      href={tokenExpired ? "/login" : "/dashboard"}
      // href="/dashboard"
      key="log_in"
      color="primary"
      className="w-full md:w-auto"
    >
      ورود به پنل
    </Button>,
    // <div key="avatar" className="flex-1 bg-red-300">

    // </div>,
    // <div
    //   key="sign_in_up"
    //   className={linksStyle + " bg-primaryColor text-white"}
    //   onClick={() => {
    //     // goToSection("cooperation");
    //   }}
    // >
    //   ثبت نام / ورود
    // </div>,
  ];
  return (
    <Sticky
      enabled={true}
      className="w-full relative"
      innerClass="flex flex-row w-full justify-center items-stretch py-2 h-[120px] relative"
      innerZ={1000}
      innerActiveClass="bg-[#ffffffcb] backdrop-blur-xl	drop-shadow-sm max-h-20 py-2 relative"
    >
      <div className="flex flex-row-reverse sm:flex-row w-full min-h-7 max-w-[1200px] gap-10 items-center justify-between sm:justify-start px-2 sm:px-0">
        <Image
          src="/assets/karabots-logo.png"
          width={110}
          height={120}
          alt="Kara Bots"
          className="w-[80px] h-full sm:w-[110px] object-contain"
        />
        <ul className="flex-row gap-8 items-center font-bold hidden sm:flex">
          {links.map((item, i) => {
            return <li key={i}>{item}</li>;
          })}
        </ul>

        <Dropdown backdrop="blur">
          <DropdownTrigger>
            <Button
              variant="bordered"
              className="flex sm:hidden p-0 min-w-14 text-secondColor text-lg"
            >
              <GiHamburgerMenu />
            </Button>
          </DropdownTrigger>
          <DropdownMenu variant="faded" aria-label="Static Actions">
            {links.map((item, i) => {
              if (i === links.length - 1) {
                return (
                  <DropdownItem
                    key={i}
                    className="py-0 !border-none !bg-transparent mt-1 !outline-none"
                  >
                    {item}
                  </DropdownItem>
                );
              } else {
                return (
                  <DropdownItem key={i} className="py-0">
                    {item}
                  </DropdownItem>
                );
              }
            })}
          </DropdownMenu>
        </Dropdown>
      </div>

      {!tokenExpired && (
        <div className="absolute left-10 top-1/2 -translate-y-1/2">
          <Dropdown isOpen={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
            <DropdownTrigger>
              <Avatar
                as="button"
                className="cursor-pointer"
                // src="/avatar.png"
                showFallback
                color="primary"
                isBordered
                size="md"
              />
            </DropdownTrigger>
            <DropdownMenu aria-label="User Menu">
              <DropdownItem key="logout" color="danger" onClick={logout}>
                <div className="flex flex-row items-center gap-2">
                  <CiLogout size={20} />
                  خروج
                </div>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      )}
    </Sticky>
  );
}
